import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/comn/hooks";
import { ptlUtils } from "@/tz/go/egaz/osci/ptl/comn";
import TanogaPortalMain, { TabStrip } from "./PortalMain/TanogaPortalMain";
import TanogaIntfStstcl from "./PortalMain/TanogaIntfStstcl";

/**
 * 시스템 운영자(auth_osci0003)는 메인 화면이 둘이다.
 * 기존 포탈 대시보드와 인터페이스 실적 통계를 상단 전환 탭으로 오간다.
 * 그 외 사용자에게는 전환 탭 없이 기존 대시보드만 보여 준다.
 */
const MAIN_SCREEN = {
    PORTAL: "P",
    INTF: "I",
};

const PortalMain = () => {
    const auth: any = useAuth();
    const { t } = useTranslation();
    const [screen, setScreen] = useState(MAIN_SCREEN.PORTAL);

    if (!ptlUtils.hasAuth("auth_osci0003", auth)) return <TanogaPortalMain />;

    return (
        <div className="w-full flex flex-col gap-[10px]">
            <TabStrip
                items={[
                    { key: MAIN_SCREEN.PORTAL, label: t("T_PTL_DSHBRD") },
                    { key: MAIN_SCREEN.INTF, label: t("T_INTF_TRMSSN_STSTC") },
                ]}
                active={screen}
                onChange={setScreen}
            />
            {screen === MAIN_SCREEN.PORTAL ? <TanogaPortalMain /> : <TanogaIntfStstcl />}
        </div>
    );
};

export default PortalMain;
